import { ReminderCollector } from "api";
import { RecipientChip } from "./sendReminderButton/types";
import { HtmlMessageParams } from "./types";

export const getChipLabel = (chip: RecipientChip) =>
  `${chip.firstName ?? ""} ${chip.lastName ?? ""} <${chip.email}>`;

export const DEFAULT_SUBJECT =
  "Action needed: missing utility data for your sites";

const DEFAULT_HELLO_MESSAGE = `Hi there,\n\nWe're missing some utility data for sites you manage. Please upload or confirm the readings below:`;
const TABLE_DESCRIPTION_MESSAGE = `If any meter has been decommissioned or the site is no longer active, you can update this in the site management page.`;
const DEFAULT_SIGNATURE_MESSAGE = `Thanks,\nTracera`;

export const DEFAULT_MESSAGE: HtmlMessageParams = {
  helloMessage: DEFAULT_HELLO_MESSAGE,
  signatureMessage: DEFAULT_SIGNATURE_MESSAGE,
  tableDescriptionMessage: TABLE_DESCRIPTION_MESSAGE,
};

const toHtml = (text?: string) =>
  text
    ? text
        .split("\n")
        .map((line) => (line.trim() ? `<p>${line}</p>` : "<br/>"))
        .join("")
    : "";

const formatMissingMonthsHtml = (
  missingMonths: string,
  partialMonths: string[] = [],
): string => {
  const missingEntries = missingMonths ? missingMonths.split(", ") : [];
  const partialEntries = partialMonths.map(
    (m) => `${m} <span style="color:#856404;font-weight:normal">(partial)</span>`,
  );
  const all = [...missingEntries, ...partialEntries];
  return all.length > 0 ? all.join(", ") : "-";
};

export const buildHtmlMessage = (
  {
    helloMessage,
    tableDescriptionMessage,
    signatureMessage,
  }: HtmlMessageParams,
  collectors: ReminderCollector[],
) => {
  const tableRows = collectors
    .map(
      (c) =>
        `<tr><td>${c.siteName ?? "-"}</td><td>${
          c.accountNumber ?? "-"
        }</td><td>${c.meterNumber ?? "-"}</td><td>${
          c.utilityTypeName ?? "-"
        }</td><td style="color:red">${
          formatMissingMonthsHtml(c.missingMonths ?? "", c.partialMonths)
        }</td></tr>`,
    )
    .join("");

  return `${toHtml(
    helloMessage,
  )}<table><thead><tr><th>Site</th><th>Account</th><th>Meter</th><th>Utility Type</th><th>Missing Months</th></tr></thead><tbody>${tableRows}</tbody></table>${toHtml(
    tableDescriptionMessage,
  )}${toHtml(signatureMessage)}`;
};
